import { jsx as _jsx } from "react/jsx-runtime";
export const Card = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `ds-c-card ${className}`,
    children: children
  });
};
export default Card;